import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Spinner = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress color="primary" size={'5rem'}/>
    </Box>
  )
}

export default Spinner